import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { handleNotificationPressAction } from '@/features/notifications/thunks/handleNotificationPressAction'
import { updateFirebaseReadNotifications } from '@/features/notifications/utils/updateFirebaseReadNotification'
import { RootState } from '@/redux/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

interface Args {
    notification: Notification
    read: boolean
    close: () => void
}

export const handlePressAction = createAsyncThunk<void, Args, { state: RootState }>(
    'notifications/NotificationCenter/ListItem/handlePressAction',
    ({ notification, read, close }, { dispatch }) => {
        dispatch(handleNotificationPressAction(notification))

        close()

        if (read) return

        updateFirebaseReadNotifications(notification)
    }
)
